<template>
    <div>
        <NuxtLayout>
            <NuxtPage />
        </NuxtLayout>
        <CobrowseSelectPreview />
        <CobrowseRemoteCursor />
    </div>
</template>

<script lang="ts" setup>
    import { useTrackerModalTracking } from './composables/useTrackerModalTracking';
    import { useTrackerPageView } from './composables/useTrackerPageView';

    const { init: initPageTracking, destroy: destroyPageTracking } = useTrackerPageView();
    const { init: initModalTracking } = useTrackerModalTracking();

    onMounted(() => {
        console.log('config cometchat app id', useRuntimeConfig().public.cometchatAppId);
        console.log('config cometchat region', useRuntimeConfig().public.cometchatRegion);
        useIntercomBoot().bootAnonymous();
        initPageTracking();
        initModalTracking();
    });

    onUnmounted(() => {
        destroyPageTracking();
    });
</script>
